import {Formik} from 'formik';

import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {
    ActionStatus,
    TestingAction,
    TestingActionRecordFormProps,
} from '../types';
import {stage} from '../../../config/stage';

export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: TestingActionRecordFormProps) => {

    // RETURN the promise (FNP-932). Dropping it here defeats FNP-925 one layer
    // down: Formik never sees a pending promise, so it clears `isSubmitting` on
    // the same tick and the Save button is disabled for ~0ms — double-submit
    // fires two mutations. The rejection also escapes unhandled, which is the
    // very thing FNP-925's commit message claimed to have removed.
    const onSubmit = (values: TestingAction) => {
        return handleSubmit(values);
    };

    const editing = Boolean(record?.id);

    // status is NonNull on create with no server default. Seed DRAFT so a new
    // action is authored in a safe state; the user can still pick ACTIVE.
    let initialValues = {status: ActionStatus.DRAFT} as TestingAction;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            enableReinitialize
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons
                    handleSubmit={handleSubmit}
                    isSubmitting={isSubmitting}
                    handleCancel={handleCancel}
                    debug={false && stage === 'ide'}
                    {...rest}
                >
                    <FormComponent editing={editing}/>
                </FormWithButtons>)}
        </Formik>
    );
};
